import { getterTypes } from '@/core/constants'

function getDadosAlteradosClassificacao(dados) {
	if (!!dados && dados.length > 0)
		return dados.filter((item) => item.classificacaoNova !== item.classificacaoAnterior)
	return []
}

export default {
	[getterTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.DADOS_ALTERAR](state) {
		const alteracoes = getDadosAlteradosClassificacao(state.alterarClassificacao.alteracoes)

		return {
			idItemAta: state.alterarClassificacao.idItemAta,
			justificativa: state.alterarClassificacao.justificativa,
			alteracoes: alteracoes,
		}
	},
}
